__webpack_require__.p = "https://dev.parcelhub.ae/fleet/tripTracking/";